/**
 * Реестр UI-дескрипторов модулей (ARCH-TASK-65.12.7).
 *
 * Модули регистрируются в composition root (`bootstrap.ts`), админка ядра
 * рендерит карточки из реестра и не импортирует экраны модулей.
 */
import type { ModuleUiDescriptor } from './types'

const DEFAULT_ORDER = 100

export class ModuleUiRegistry {
  private readonly modules = new Map<string, ModuleUiDescriptor>()

  /** Зарегистрировать UI модуля (повторный id — предупреждение и игнор). */
  register(descriptor: ModuleUiDescriptor): this {
    if (this.modules.has(descriptor.id)) {
      console.warn(`[modules] UI модуля "${descriptor.id}" уже зарегистрирован — игнор`)
      return this
    }
    this.modules.set(descriptor.id, descriptor)
    return this
  }

  get(id: string): ModuleUiDescriptor | undefined {
    return this.modules.get(id)
  }

  /** Модули в порядке отображения (order, затем заголовок). */
  list(): ModuleUiDescriptor[] {
    return [...this.modules.values()].sort((a, b) => {
      const order = (a.order ?? DEFAULT_ORDER) - (b.order ?? DEFAULT_ORDER)
      if (order !== 0) return order
      return a.title.localeCompare(b.title, 'ru')
    })
  }
}
